import React from "react";
import { useQuery } from "@apollo/react-hooks";

import "./mobile-new-products-style.scss";
import useIsComDomain from "@src/hooks/useIsComDomain";

import MobileProductListSkeleton from "@src/componentsNew/Skeleton/mobile/components/MobileProductListSkeleton";
import ProductListTitle from "@src/componentsNew/ProductListTitle/ProductListTitle";
import SectionDivider from '@src/componentsNew/SectionDivider';
import MobileVerticalProductThumbnail from "@src/componentsNew/ProductThumbnail/VerticalProductThumbnail/MobileVerticalProductThumbnail";

import { mobileNewProducts } from "@organisms/NewProducts/__generated__/mobileNewProducts";
import { MOBILE_NEW_PRODUCT_LIST } from "@organisms/NewProducts/queries";

const MobileNewProducts = () => {
  const isComDomain = useIsComDomain();

  const { data, error, loading } = useQuery<mobileNewProducts>(MOBILE_NEW_PRODUCT_LIST, {
    fetchPolicy: "network-only",
    variables: {
      first: 12,
      isMgs: isComDomain ? true : false
    },
  });

  if (loading) {
    return (
      <MobileProductListSkeleton
        type="horizontal"
        hasTitle={true}
        hasBottomDivider={true} />
    );
  }

  return (
    data && data.products.totalCount > 0 ? (
      <div className="mobile-new-products-wrapper">
        <ProductListTitle
          title="New Arrivals"
          typoVariant="h8"
          typoComponent="h4" />

        <div className="mobile-new-product-thumbnails-wrapper">
          {
            data.products.edges.map((item, idx) =>
              <MobileVerticalProductThumbnail key={idx} product={item.node} isVerticalOne={false} />
            )
          }
        </div>

        <SectionDivider style={{ marginTop: "24px" }} />
      </div>
    ) : null
  );
};

export default MobileNewProducts;
